/* -- set app title --*/
const AppTitle = 'FRONTEND MIGRATR';

/*-- set app mode --*/
// const AppMode = [''];
const AppMode = ['production']; // ECS Server is deployed new changes

/* -- set API URLs --*/
const development = 'https://oldmigratr.instrumental.net';
const production = 'https://oldmigratrv2.instrumental.net';

let ApiUrl, baseURL, env = AppMode[0];
switch (AppMode[0]) {
  case 'development':
    ApiUrl = development;
    baseURL = 'https://migratr.instrumental.net';
    break;
  case 'production':
    ApiUrl = production;
    baseURL = 'https://migratr.instrumental.net';
    break;
  default:
    ApiUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:3002';
    baseURL = 'http://localhost:4001';
};

ApiUrl = `${ApiUrl}/api/`;
console.log('****** ApiUrl = ', ApiUrl);
export { AppTitle, ApiUrl, baseURL, env };
